var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cus-chat-supervise" },
    [
      _c(
        "div",
        { staticClass: "cus-chat-supervise-search" },
        [
          _c(
            "el-select",
            {
              staticStyle: { width: "150px" },
              attrs: { placeholder: "请选择", size: "mini" },
              on: {
                change: function($event) {
                  return _vm.getTableData(true)
                }
              },
              model: {
                value: _vm.formInline.bindStatus,
                callback: function($$v) {
                  _vm.$set(_vm.formInline, "bindStatus", $$v)
                },
                expression: "formInline.bindStatus"
              }
            },
            _vm._l(_vm.options, function(item) {
              return _c("el-option", {
                key: item.bindStatus,
                attrs: { label: item.label, value: item.bindStatus }
              })
            }),
            1
          ),
          _c(
            "div",
            { staticStyle: { width: "250px", display: "inline-block" } },
            [
              _c(
                "el-input",
                {
                  attrs: {
                    size: "mini",
                    placeholder: "档案名/卡号/昵称/备注名",
                    clearable: ""
                  },
                  on: {
                    blur: function($event) {
                      return _vm.getTableData(true)
                    },
                    clear: function($event) {
                      return _vm.getTableData(true)
                    }
                  },
                  model: {
                    value: _vm.formInline.queryCustomerChat,
                    callback: function($$v) {
                      _vm.$set(_vm.formInline, "queryCustomerChat", $$v)
                    },
                    expression: "formInline.queryCustomerChat"
                  }
                },
                [
                  _c("i", {
                    staticClass: "el-input__icon el-icon-search",
                    attrs: { slot: "suffix" },
                    slot: "suffix"
                  })
                ]
              )
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { display: "flex", "align-items": "center" } },
            [
              _c("el-button", { attrs: { size: "mini" } }, [
                _vm._v(" 上次聊天 ")
              ]),
              _c("el-date-picker", {
                staticStyle: { width: "240px", "border-radius": "0 4px 4px 0" },
                attrs: {
                  "picker-options": _vm.pickerOptions,
                  size: "mini",
                  type: "daterange",
                  editable: false,
                  "value-format": "yyyy-MM-dd",
                  "range-separator": "~",
                  "start-placeholder": "开始时间",
                  "end-placeholder": "结束时间",
                  clearable: ""
                },
                on: { change: _vm.selectTime },
                model: {
                  value: _vm.dateArr,
                  callback: function($$v) {
                    _vm.dateArr = $$v
                  },
                  expression: "dateArr"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "code-search-left" },
            [
              _c("el-button", { attrs: { size: "mini" } }, [
                _vm._v(" 跟进员工 ")
              ]),
              _c(
                "el-tag",
                {
                  staticClass: "add-per-input",
                  attrs: {
                    title: "选择员工",
                    closable: this.searchMenNames.length === 0 ? false : true,
                    type: "medium",
                    effect: "plain"
                  },
                  on: {
                    close: _vm.searchCloseTag,
                    click: function($event) {
                      return _vm.clickAddMember(true)
                    }
                  }
                },
                [
                  _vm.searchMenNames.length === 0
                    ? _c("span", [_vm._v("选择员工")])
                    : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "span-tips" },
                    _vm._l(_vm.searchMenNames, function(item, index) {
                      return _c("span", { key: index }, [
                        _vm._v(_vm._s(item.name)),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.searchMenNames.length > 1 &&
                                  index != _vm.searchMenNames.length - 1,
                                expression:
                                  "searchMenNames.length > 1 && index != searchMenNames.length - 1\n              "
                              }
                            ]
                          },
                          [_vm._v(",")]
                        )
                      ])
                    }),
                    0
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            [
              _c(
                "el-table",
                {
                  ref: "cusChatTable",
                  staticStyle: { "font-size": "13px" },
                  attrs: {
                    size: "small",
                    data: _vm.tableData,
                    fit: "",
                    "highlight-current-row": "",
                    align: "center",
                    "header-cell-style": { background: "#F9F9F9" },
                    height: _vm.tableHeight
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "序号", width: "80" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(_vm.getGlobalIndex(scope.$index)) +
                                " "
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "name",
                      label: "客户",
                      "min-width": "250",
                      "show-overflow-tooltip": ""
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(" " + _vm._s(scope.row.name)),
                            scope.row.type == 1
                              ? _c(
                                  "span",
                                  {
                                    staticStyle: { color: "rgb(70, 189, 10)" }
                                  },
                                  [_vm._v(" @微信")]
                                )
                              : _c(
                                  "span",
                                  {
                                    staticStyle: { color: "rgb(8, 168, 231)" }
                                  },
                                  [_vm._v(" @" + _vm._s(scope.row.corpName))]
                                )
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "employee",
                      label: "档案名",
                      "min-width": "150",
                      "show-overflow-tooltip": ""
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            scope.row.ctmName != null
                              ? _c("span", [_vm._v(_vm._s(scope.row.ctmName))])
                              : _c(
                                  "span",
                                  {
                                    staticStyle: { color: "rgb(228, 96, 63)" }
                                  },
                                  [_vm._v("未绑定")]
                                )
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "ctmCode",
                      label: "卡号",
                      "min-width": "180"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "chargePerson",
                      label: "跟进员工",
                      width: "120",
                      "show-overflow-tooltip": ""
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            scope.row.chargePerson == null
                              ? _c(
                                  "span",
                                  { staticStyle: { color: "#FFAA33" } },
                                  [_vm._v("无跟进员工")]
                                )
                              : _c("span", [
                                  _vm._v(_vm._s(scope.row.chargePerson))
                                ])
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "recentTime",
                      label: "上次聊天",
                      width: "200"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            scope.row.recentTime == null
                              ? _c(
                                  "span",
                                  { staticStyle: { color: "#FFAA33" } },
                                  [_vm._v("无上次聊天时间")]
                                )
                              : _c("span", [
                                  _vm._v(_vm._s(scope.row.recentTime))
                                ])
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "operation", label: "操作", width: "130" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-link",
                              {
                                staticStyle: { "font-size": "13px" },
                                attrs: {
                                  underline: false,
                                  type: "primary",
                                  icon: "el-icon-view"
                                },
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.viewContent(
                                      scope.$index,
                                      scope.row
                                    )
                                  }
                                }
                              },
                              [_vm._v("聊天内容")]
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("el-pagination", {
        staticStyle: { "text-align": "end", "margin-top": "6px" },
        attrs: {
          "current-page": _vm.formInline.page,
          "page-size": _vm.formInline.size,
          layout: "total, sizes, prev, pager, next, jumper",
          total: _vm.total,
          "page-sizes": [20, 50, 100, 200, 500]
        },
        on: {
          "current-change": _vm.changePage,
          "size-change": _vm.changeSize,
          "update:currentPage": function($event) {
            return _vm.$set(_vm.formInline, "page", $event)
          },
          "update:current-page": function($event) {
            return _vm.$set(_vm.formInline, "page", $event)
          },
          "update:pageSize": function($event) {
            return _vm.$set(_vm.formInline, "size", $event)
          },
          "update:page-size": function($event) {
            return _vm.$set(_vm.formInline, "size", $event)
          }
        }
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.chatTitle,
            visible: _vm.dialogVisible,
            "close-on-click-modal": false,
            width: "50vw",
            center: true,
            "close-on-press-escape": true
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.close
          }
        },
        [
          _vm.newChatDialogVisible
            ? _c("ChatContentDia", { attrs: { idData: _vm.uid } })
            : _vm._e()
        ],
        1
      ),
      _c("StaffTree", {
        attrs: {
          title: _vm.title,
          dialogVisibleTree: _vm.dialogVisibleTree,
          currentSelectMember: _vm.currentSelectMember
        },
        on: { closeTree: _vm.closeTree, clickSubmitTree: _vm.clickSubmitTree }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }